<div class="modal-signup modal-content border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">
        <div class="row">
          <div class="col-md-10 padding-left-0px">
            <label class="margin-bottom-0px color-Assign font-weight-bold">Material ({{Description}})</label>
          </div>
          <div class="col-md-2 float-right">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Material Group :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{GroupName}}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Name :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{Description}}</label>
              </div>
            </div>
          </div>
        </div>

        <!--<div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Sell Unit :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{SaleUOM}}</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Purchase Unit :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{PurchaseUOM}}</label>
              </div>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Hsn Code :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{HsnCode}}</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Tax(%) :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{TaxPercent}}</label>
              </div>
            </div>
          </div>

        </div>-->

      </div>

      <div class="modal-body padding-top-0px padding-bottom-0px">
        <div class="">
            <form class="form" novalidate="" (ngSubmit)="SaveMaterial()" #f="ngForm">

              <div class="card">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general padding-top-0px">

                          <div class="row" *canUserAccess="['HL_ER_MatGroupName']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-4 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Material Group</label>
                                </div>

                                <div class="col-md-5">
                                  <CustomDataByRequestType RequestedType="Material Groups " class="form-group" SelectedValue="StoreCode"
                                                           [(ngModel)]="MaterialGroupCode" (keyChange)="onAssignedToActorCodesurgeon2($event)"
                                                           name="MaterialGroupCodename" #sign2="ngModel">
                                  </CustomDataByRequestType>
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row" *canUserAccess="['HL_ER_MatName']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-4 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Name</label>
                                </div>

                                <div class="col-md-5">
                                  <input type="text" class="form-control" placeholder="Name"
                                         id="UpdatedDescription"
                                         [(ngModel)]="UpdatedDescription"
                                         name="UpdatedDescription" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" required #UpdDescription="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!UpdDescription.valid && (UpdDescription.dirty || UpdDescription.touched) && UpdDescription.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!UpdDescription.valid && UpdDescription.errors.pattern)">(special characters are not allowed)</small>

                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-4 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Sell Unit</label>
                                </div>

                                <div class="col-md-5">
                                  <input type="text" class="form-control" placeholder="Sell Unit"
                                         id="UpdatedSaleUOM"
                                         [(ngModel)]="UpdatedSaleUOM"
                                         name="UpdatedSaleUOM" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" required #UpdSaleUOM="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!UpdSaleUOM.valid && (UpdSaleUOM.dirty || UpdSaleUOM.touched) && UpdSaleUOM.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!UpdSaleUOM.valid && UpdSaleUOM.errors.pattern)">(special characters are not allowed)</small>
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Purchase Unit</label>
                                </div>
                                <div class="col-md-5">
                                  <input type="text" class="form-control" placeholder="Purchase Unit"
                                         id="UpdatedPurchaseUOM"
                                         [(ngModel)]="UpdatedPurchaseUOM"
                                         name="UpdatedPurchaseUOM" #UpdPurchaseUOM="ngModel"
                                         maxlength="6" pattern="[0-9]{6}" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!UpdPurchaseUOM.valid && (UpdPurchaseUOM.dirty || UpdPurchaseUOM.touched) && UpdPurchaseUOM.errors.required )">
                                    (Field cannot be left blank)
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Hsn Code</label>
                                </div>
                                <div class="col-md-5">
                                  <input type="text" class="form-control" placeholder="Hsn Code"
                                         id="UpdatedHsnCode"
                                         [(ngModel)]="UpdatedHsnCode"
                                         name="UpdatedHsnCode" #UpdHsnCode="ngModel"
                                         maxlength="6" pattern="[0-9]{6}" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!UpdHsnCode.valid && (UpdHsnCode.dirty || UpdHsnCode.touched) && UpdHsnCode.errors.required )">
                                    (Field cannot be left blank)
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Tax %</label>
                                </div>
                                <div class="col-md-5">
                                  <CodeTypeValue CodeType="TAXPC" id="UpdatedTaxPercent"
                                                 [(ngModel)]="UpdatedTaxPercent" SelectedValue=""
                                                 name="UpdatedTaxPercent">
                                  </CodeTypeValue>                              
                                  
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">OK</button>                           
                  <button type="button" class="btn btn-secondary btn-raised margin-right-15px float-right button-Schedule actions-btn-prime actions-btn-prime3 font-size-13px" (click)="activeModal.close('Close click')">Cancel</button>
                </div>
              </div>
            </form>        
        </div>
      </div>
    </div>
  </div>
</div>
